import { useState } from 'react';

import axios from 'axios';

export default function useRDStation() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const subscribe = ({
    name,
    email = '',
    mobilePhone,
    conversionIdentifier,
    campaign,
    onSuccess = () => {},
    onError = () => {},
    onFinally = () => {},
  }) => {
    if (!email) {
      setError(true);
    } else {
      setLoading(true);
      setError(false);

      axios
        .post('/api/rdstation/conversion', {
          name,
          email,
          mobilePhone,
          conversionIdentifier,
          campaign,
        })
        .then(res => {
          setMessage(`E-mail ${email} foi cadastrado com sucesso! Aguarde novidades.`);

          setTimeout(() => {
            setMessage('');
          }, 5000);

          onSuccess(res?.data);
        })
        .catch(err => {
          setError(true);
          setMessage(err.response?.data?.message);

          onError(err);
        })
        .then(() => {
          setLoading(false);
          onFinally();
        });
    }
  };

  return { message, error, loading, subscribe, setError, setMessage, setLoading };
}
